import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum.js';

export default Object.freeze({
	GENERAL: `${RouteNames.ACTIVITY_TYPES}-general`,
});
